/**
 * @generated SignedSource<<e3294c78419cc6ddaef5c20aef4fd811>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteSubstitutionInput = {
  substitutionId: string;
};
export type DeleteSubstitutionMutation$variables = {
  input: DeleteSubstitutionInput;
};
export type DeleteSubstitutionMutation$data = {
  readonly deleteSubstitution: {
    readonly deletedSubstitutionId: string | null | undefined;
  } | null | undefined;
};
export type DeleteSubstitutionMutation = {
  response: DeleteSubstitutionMutation$data;
  variables: DeleteSubstitutionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSubstitutionPayload",
    "kind": "LinkedField",
    "name": "deleteSubstitution",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSubstitutionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteSubstitutionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteSubstitutionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5e502320d76be9d17973f512a23de972",
    "id": null,
    "metadata": {},
    "name": "DeleteSubstitutionMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteSubstitutionMutation(\n  $input: DeleteSubstitutionInput!\n) {\n  deleteSubstitution(input: $input) {\n    deletedSubstitutionId\n  }\n}\n"
  }
};
})();

(node as any).hash = "1be1b665a580091dcf81ce212d5c2f2a";

export default node;
